export default "__VITE_ASSET__9432323d__"